import {Routes} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {TourComponent} from './components/tour/tour.component';
import {ShoppingCartPageComponent} from './components/shopping-cart-page/shopping-cart-page.component';

export const routes: Routes = [
  {path: '', pathMatch: 'full', component: HomeComponent},
  {path: 'tour/:tourName', component: TourComponent},
  {path: 'shopping-cart', component: ShoppingCartPageComponent},

  {path: 'ru', pathMatch: 'full', component: HomeComponent},
  {path: 'ru/tour/:tourName', component: TourComponent},
  {path: 'ru/shopping-cart', component: ShoppingCartPageComponent}
];
